module.exports = __webpack_public_path__ + "img/arrow.12f9371e.svg";